import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const existsInDatahub: Columns<any> = {
  title: 'DataHub',
  key: 'existsInDataHub',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    0: { color: 'bg-red-500', label: 'common.no' },
    1: { color: 'bg-green-500', label: 'common.yes' },
  }
}
